"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddBodyApi = AddBodyApi;
exports.BodyInfoApi = BodyInfoApi;
exports.BodyListApi = BodyListApi;
exports.UpdateBodyApi = UpdateBodyApi;
exports.zyypListApi = zyypListApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 文章详情
 * @param id
 * @constructor
 */
function BodyInfoApi(param) {
  var data = {
    rowId: param.id
  };
  return (0, _request.default)({
    url: '/admin/body/detail',
    method: 'get',
    params: data
  });
}

/**
 * 体质列表
 * @param pram
 * @constructor
 */
function BodyListApi() {
  return (0, _request.default)({
    url: '/admin/body/list',
    method: 'GET',
    params: {}
  });
}

/**
 * 中药饮片列表
 * @param pram
 * @constructor
 */
function zyypListApi(keywords) {
  var data = {
    keywords: keywords
  };
  return (0, _request.default)({
    url: '/admin/body/getZyypList',
    method: 'GET',
    params: data
  });
}

/**
 * 新增体质
 * @param pram
 * @constructor
 */
function AddBodyApi(pram) {
  var data = {
    author: pram.author,
    cid: pram.cid
  };
  return (0, _request.default)({
    url: '/admin/body/save',
    method: 'post',
    data: data
  });
}

/**
 * 更新体质
 */
function UpdateBodyApi(data) {
  return (0, _request.default)({
    url: '/admin/body/save',
    method: 'post',
    data: data
  });
}